<template>
  <div class="expandable-abstract" :style="cssVars">
    <div ref="abstract" class="abstract mb-1" :class="{ expanded }">
      <highlightable-content :highlight-terms="highlights">
        {{ abstract }}
      </highlightable-content>
    </div>
    <div class="expand-button primary--text" @click="onExpand">
      <v-icon color="primary" :class="{ expanded }">
        expand_more
      </v-icon>
      {{ expandButtonText }}
    </div>
  </div>
</template>

<script>
import HighlightableContent from '@/components/Common/HighlightableContent';

export default {
  name: 'ExpandableAbstract',
  components: { HighlightableContent },
  props: {
    abstract: {
      type: String,
      default: null,
    },
    highlights: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    expanded: false,
    fullHeight: 0,
    animationDuration: '0s',
  }),
  computed: {
    cssVars() {
      return {
        '--full-height': `${this.fullHeight}px`,
        '--animation-duration': this.animationDuration,
      };
    },
    expandButtonText() {
      return this.expanded
        ? 'Collapse abstract'
        : 'Expand to read full abstract';
    },
  },
  mounted() {
    this.fullHeight = this.$refs.abstract.scrollHeight;
  },
  methods: {
    onExpand() {
      // Duration is initialised to 0s to prevent animation from playing on mount.
      this.animationDuration = '0.5s';
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

$expandable-abstract-collapse-height: 3 * 1.75em;

.expandable-abstract {
  .abstract {
    line-height: 175%;
    font-size: 14px;
    font-weight: 300;
    color: map-get($grey, 'darken-4');

    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;

    animation-name: collapseAbstract;
    animation-duration: var(--animation-duration);
    animation-fill-mode: forwards;

    &.expanded {
      animation-name: expandAbstract;
      animation-duration: 0.5s;
    }
  }

  .expand-button {
    user-select: none;
    cursor: pointer;

    font-size: 14px;
    font-weight: 300;

    .v-icon {
      transition: transform 0.2s;

      &.expanded {
        transform: rotate(180deg);
      }
    }
  }
}

@keyframes expandAbstract {
  0% {
    max-height: $expandable-abstract-collapse-height;
  }
  100% {
    max-height: var(--full-height);
  }
}

@keyframes collapseAbstract {
  0% {
    max-height: var(--full-height);
  }
  0%,
  95% {
    -webkit-line-clamp: unset;
    -webkit-box-orient: unset;
  }
  100% {
    max-height: $expandable-abstract-collapse-height;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>
